function generateTableKey(componentEntryState, sortOptions, appliedTimespan) {
  return `${componentEntryState.query}-${appliedTimespan}-${Object.keys(componentEntryState.filters.productIds).join(",")}-${Object.keys(componentEntryState.filters.studentIds).join(",")}-${Object.keys(componentEntryState.filters.teamIds).join(",")}-${sortOptions.sortBy}-${sortOptions.direction}`;
}

export { generateTableKey };
//# sourceMappingURL=table-key.js.map
